import { type BaseNodeData } from '../types';
import { BaseNode } from './BaseNode';
import { nodeStyles } from './styles';

interface TaskNodeProps {
	data: BaseNodeData;
	selected?: boolean;
}

export function TaskNode({ data, selected }: TaskNodeProps) {
	return (
		<BaseNode
			data={data}
			selected={selected}
			containerStyle={nodeStyles.taskContainer}
			showSourceHandle={false}
			targetPosition={data.targetPosition}
			sourcePosition={data.sourcePosition}
			icon={
				<svg width='16' height='16' viewBox='0 0 16 16' fill='none'>
					<rect x='3' y='3' width='10' height='10' rx='2' stroke='#f59e0b' strokeWidth='1.5' fill='none' />
					<path d='M6 8l1.5 1.5L11 6' stroke='#f59e0b' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
				</svg>
			}
		/>
	);
}
